import { RECEIVE_VALIDATE_2FA_REQUIRED_ENDPOINTS } from '../actions/apiActions';
export default function api() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    validate2FARequiredEndpoints: {}
  };
  var action = arguments[1];
  switch (action.type) {
    case RECEIVE_VALIDATE_2FA_REQUIRED_ENDPOINTS:
      return Object.assign({}, state, {
        validate2FARequiredEndpoints: action.payload.reduce(makeObjFromArray, {})
      });
    default:
      return state;
  }
}
var makeObjFromArray = function makeObjFromArray(acc, el) {
  acc[el] = true;
  return acc;
};